import React from "react";
import UploadContactIcon from "Assets/png/contactUpload.png";
import DoNotContactDomainUploadIcon from "Assets/png/blockedDomain.png";
import { observer } from "mobx-react";
import Utils from "Utils/utils";
import { toasterState } from "../toaster";

const CsvUpload = observer(props => {
  const {
    csvUploadCbk,
    settingsFlag = false,
    keyText = "contact"
  } = props || {};

  const changeInputVal = e => {
    const file = e?.target?.files?.[0];
    const allowedFormats = [".csv", ".xls", ".txt"];
    if (file) {
      const fileExtension = "." + file?.name?.split(".").pop().toLowerCase();
      if (allowedFormats.includes(fileExtension)) {
        Utils.preventDefaultFn(e);
        submitAction(e);
      } else {
        toasterState.setToastMsg(
          "Invalid file format. Please select a CSV, Excel, or text file.",
          "failure"
        );
      }
    }
  };

  const submitAction = value => {
    csvUploadCbk(value);
  };

  const downloadLink = () => {
    const link = document.createElement("a");
    const content = `First Name,Last Name,Email Address,Job Title,Phone Number,Mobile Number,Other Number,Company Name,Industry,Street,City,State,Country,Zip code,Website,LinkedIn URL,Twitter,Custom Field 1,Custom Field 2,Custom Field 3
John,Doe,john.doe@example.com,Sales Manager,+1 555 210 1234,+1 555 210 5678,+1 555 210 9012,Example Corp,Technology,123 Business Ave,San Francisco,California,United States,94105,www.example.com,https://linkedin.com/in/johndoe,https://twitter.com/johndoe,Custom Value 1,Custom Value 2,Custom Value 3
Jane,Smith,jane.smith@example.com,Marketing Director,+1 555 310 1234,+1 555 310 5678,,Acme Solutions,Marketing,456 Market St,New York,New York,United States,10001,www.acme.com,https://linkedin.com/in/janesmith,,Custom Value A,Custom Value B,Custom Value C
Michael,Lee,michael.lee@example.com,Founder,+44 20 7946 0958,,,Global Ventures,Consulting,78 King St,London,,United Kingdom,EC2V 8BB,www.globalventures.com,https://linkedin.com/in/michaellee,https://twitter.com/michaellee,Custom Entry 1,Custom Entry 2,Custom Entry 3`;
    const blob = new Blob(["\ufeff", content]);
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.setAttribute("download", "sample.csv");
    link.click();
  };

  const imageObj = {
    contact: UploadContactIcon,
    doNotContact: DoNotContactDomainUploadIcon
  };

  return (
    <div className="uploadWrapper">
      <div className="fileUploadContainer">
        <div className="imageCont">
          <img src={imageObj[keyText]} alt="" />
        </div>
        <div className="fileUploadWrapper">
          <div className="fileUploadCont">
            <span>Drag and drop or click </span>
            <span className="hereTxt">here</span>
            <input
              className="fileuploadInput"
              id="fileUpload"
              type="file"
              accept=".csv, .xls, .txt"
              onChange={e => changeInputVal(e)}
            />
          </div>
        </div>
      </div>
      {settingsFlag && (
        <div className="sampleFile">
          You can only upload a CSV file upto 100 domains
        </div>
      )}
      {!settingsFlag && (
        <div className="sampleFile">
          To download a sample CSV file, click
          <span className="clickHereLink" onClick={downloadLink}>
            here
          </span>
        </div>
      )}
    </div>
  );
});

export default CsvUpload;
export { CsvUpload };
